import { inject, Injectable } from '@angular/core';
import { RouteIds, Step } from '../types';
import {
  ApplicantStepDefinitionService,
  BookingStepDefinitionService,
  ConfirmationStepDefinitionService,
  CourseStepDefinitionService,
  ExtrasStepDefinitionService,
  PaymentStepDefinitionService,
  QuoteStepDefinitionService,
  StepDefinitionStrategy,
} from './step-definition';
import { AyaQuoteStepDefinitionService } from './step-definition/aya-quote-step-definition.service';
import { Flow } from '@lx/quote-tool/lite/shared/types';

/**
 * Service to get the step definition.
 * It has a list of strategies (one per each step) to be able to get the definition of each step
 * based on the step id.
 *
 * One of the things that this service does is to get the navigation bar items per each step.
 *
 */
@Injectable({
  providedIn: 'root',
})
export class StepDefinitionService {
  private readonly courseStepStrategy = inject(CourseStepDefinitionService);
  private readonly extrasStepStrategy = inject(ExtrasStepDefinitionService);
  private readonly applicantStepStrategy = inject(ApplicantStepDefinitionService);
  private readonly quoteStepStrategy = inject(QuoteStepDefinitionService);
  private readonly ayaQuoteStepStrategy = inject(AyaQuoteStepDefinitionService);
  private readonly bookingStepStrategy = inject(BookingStepDefinitionService);
  private readonly confirmationStepStrategy = inject(ConfirmationStepDefinitionService);
  private readonly paymentStepStrategy = inject(PaymentStepDefinitionService);

  private readonly strategies: Record<RouteIds, StepDefinitionStrategy> | undefined;

  constructor() {
    this.strategies = {
      course: this.courseStepStrategy,
      extras: this.extrasStepStrategy,
      applicant: this.applicantStepStrategy,
      quote: this.quoteStepStrategy,
      'aya-quote': this.ayaQuoteStepStrategy,
      booking: this.bookingStepStrategy,
      confirmation: this.confirmationStepStrategy,
      payment: this.paymentStepStrategy,
    };
  }

  /**
   * Gets the step definition for the given step id.
   */
  getStepDefinition(stepId: RouteIds, activeFlow: Flow): Step {
    return this.strategies[stepId].getStepDefinition(activeFlow);
  }
}
